import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Login from '../../../pages/Login';
import ForgotPassword from '../../../pages/ForgotPassword';

const GustRouts = () => {
  return (

    <Routes>
    <Route path="/" element={<Navigate to="/login" />} />
    <Route path="/login" element={<Login />} />
    <Route path="/forgot-password" element={<ForgotPassword />} />
  </Routes>
  );
};

export default GustRouts;
